import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Input,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { switchToAccount } from '../actions/Auth';

const SwitchAccountSwitch = ({ profile }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const searchInputRef = useRef();

  useEffect(() => {
    if (isOpen && profile.is_superadmin) {
      searchInputRef.current.focus();
    }
  }, [isOpen, profile.is_superadmin]);

  if (
    !profile ||
    !profile.accounts ||
    profile.accounts.length === 0
  ) {
    return null;
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleKeyUp = (e) => {
    if (e.key === 'Escape') {
      setSearch('');
    }
  };

  const accounts = search ?
    profile.accounts.filter(account => (
      account.domain.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      account.name.toLowerCase().indexOf(search.toLowerCase()) >= 0
    )) :
    profile.accounts;

  return (
    <>
      <UncontrolledDropdown
        nav
        className="account-switcher"
        direction="right"
        onToggle={(e, isToggleOpen) => { setIsOpen(isToggleOpen); }}
      >
        <DropdownToggle
          nav
          id="account-switcher-icon"
          className={classnames('nav-account-switcher', { active: isOpen })}
        >
          <span className="nav-item-icon">
            <i className="fas fa-swap fa-rotate-90" />
          </span>
        </DropdownToggle>
        <DropdownMenu className="account-switcher-dropdown" right container="nav.sidebar">
          <DropdownItem header>
            {intl.formatMessage({ defaultMessage: 'Switch to account' })}
          </DropdownItem>
          {profile.is_superadmin && (
            <DropdownItem header>
              <Input
                innerRef={searchInputRef}
                bsSize="sm"
                type="text"
                name="account-search"
                placeholder={intl.formatMessage({ defaultMessage: 'Type to search' })}
                onChange={handleSearchChange}
                onKeyUp={handleKeyUp}
                value={search}
              />
            </DropdownItem>
          )}
          {accounts.map(account => (
            <DropdownItem
              key={account.uuid}
              disabled={account.uuid === profile.client.uuid}
              onClick={() => { switchToAccount(account.uuid); }}
            >
              <div className="account-icon" style={{ backgroundColor: account.color }}>
                <span>{account.name.substring(0, 1)}</span>
              </div>
              <span>{account.name}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
      <UncontrolledTooltip fade={false} target="account-switcher-icon" className={isOpen ? 'hidden' : ''} container="body" boundariesElement="nav.sidebar" placement="right">
        {intl.formatMessage({ defaultMessage: 'Switch to account' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  originalProfile: state.Auth.originalProfile,
});

SwitchAccountSwitch.propTypes = {
  profile: PropTypes.object,
};

SwitchAccountSwitch.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(SwitchAccountSwitch);
